/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BindRequest } from '../models/BindRequest';
import type { ImpersonateRequest } from '../models/ImpersonateRequest';
import type { SuccessResponse_BindResponse_ } from '../models/SuccessResponse_BindResponse_';
import type { SuccessResponse_LogoutResponse_ } from '../models/SuccessResponse_LogoutResponse_';
import type { SuccessResponse_WechatLoginResponse_ } from '../models/SuccessResponse_WechatLoginResponse_';
import type { SwitchStoreRequest } from '../models/SwitchStoreRequest';
import type { WechatLoginRequest } from '../models/WechatLoginRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AuthService {
    /**
     * Wechat Login Endpoint
     * POST /api/v1/auth/wechat-login — 微信 code 换 JWT.
     * @returns SuccessResponse_WechatLoginResponse_ Successful Response
     * @throws ApiError
     */
    public static wechatLoginEndpointApiV1AuthWechatLoginPost({
        requestBody,
    }: {
        requestBody: WechatLoginRequest,
    }): CancelablePromise<SuccessResponse_WechatLoginResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/auth/wechat-login',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Bind Endpoint
     * POST /api/v1/auth/bind — 扫码绑定 OpenID.
     * @returns SuccessResponse_BindResponse_ Successful Response
     * @throws ApiError
     */
    public static bindEndpointApiV1AuthBindPost({
        requestBody,
    }: {
        requestBody: BindRequest,
    }): CancelablePromise<SuccessResponse_BindResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/auth/bind',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Impersonate Endpoint
     * POST /api/v1/auth/impersonate — 超管变身 (Ricky 2026-07-07).
     *
     * 仅 super_admin; 签发目标员工等价登录 JWT (权限/RLS/可写面与本人一致),
     * 审计 auth.impersonate。响应复用 BindResponse, 前端按登录同款处理。
     * @returns SuccessResponse_BindResponse_ Successful Response
     * @throws ApiError
     */
    public static impersonateEndpointApiV1AuthImpersonatePost({
        requestBody,
    }: {
        requestBody: ImpersonateRequest,
    }): CancelablePromise<SuccessResponse_BindResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/auth/impersonate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Switch Store Endpoint
     * POST /api/v1/auth/switch-store — 店长切店 (072 多店挂载, 首例赵乐).
     *
     * 仅店长(以 dim_employee.position 为真相); 目标必须是主店或当前生效挂载店,
     * 否则 403。换发 store_id=目标店 的 JWT, 排班/考勤/审批等 own_store 守卫
     * 随之整体切换; 审计 auth.switch_store。响应复用 BindResponse。
     * @returns SuccessResponse_BindResponse_ Successful Response
     * @throws ApiError
     */
    public static switchStoreEndpointApiV1AuthSwitchStorePost({
        requestBody,
    }: {
        requestBody: SwitchStoreRequest,
    }): CancelablePromise<SuccessResponse_BindResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/auth/switch-store',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Switch External Viewer Store Endpoint
     * Reissue a store-scoped viewer credential through the sole write-block exception.
     * @returns SuccessResponse_BindResponse_ Successful Response
     * @throws ApiError
     */
    public static switchExternalViewerStoreEndpointApiV1AuthExternalViewerSwitchStorePost({
        requestBody,
    }: {
        requestBody: SwitchStoreRequest,
    }): CancelablePromise<SuccessResponse_BindResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/auth/external-viewer/switch-store',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Logout Endpoint
     * POST /api/v1/auth/logout — 吊销当前员工所有旧 JWT.
     * @returns SuccessResponse_LogoutResponse_ Successful Response
     * @throws ApiError
     */
    public static logoutEndpointApiV1AuthLogoutPost(): CancelablePromise<SuccessResponse_LogoutResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/auth/logout',
        });
    }
}
